import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import DataDrivenLogoColumn from '../../components/columns/data-driven-logo-column';
import GetMarketplaceDisplayName from '../../components/data-driven-logo/get-marketplace-display-name';

const mapStateToProps = (state, props) => {
  const { marketplaceId, type, marketplaceUsername } = props;

  if (!marketplaceId) {
    return {
      isEmpty: true,
    };
  }

  const displayName = GetMarketplaceDisplayName(marketplaceId);
  return {
    dataDrivenLogoProps: { marketplaceId: Number.parseInt(marketplaceId, 10) },
    message: type && type === 'marketplaces' ? <FormattedMessage {...displayName} /> : marketplaceUsername,
  };
};

export const MarketplacesColumnContainer = connect(mapStateToProps)(DataDrivenLogoColumn);
